import { useQueryClient } from '@tanstack/react-query';
import { Drawer, Flex, Table } from 'antd';
import { BaseButton } from 'components/button/button-base';
import { PrintableRootPage } from 'components/page/page-2';
import { useGetOrganizations } from 'lib/hooks/tanstack/useGetOrganizations';
import { useState } from 'react';
import { AddOrganizationDrawer } from './drawer-add-organisation';
import { useErrorList } from 'lib/utils/useErrorList';
import { useQueryErrorNotifier } from 'lib/hooks/use-query-error-notifier';

const columns = [
  {
    title: 'Business Name',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'Contact Email',
    dataIndex: ['billing', 'primaryContact', 'email'],
    key: 'billingPrimaryContactEmail'
  },
  {
    title: 'Phone Number',
    dataIndex: 'phoneNumber',
    key: 'phoneNumber'
  },
  {
    title: 'City',
    dataIndex: 'city',
    key: 'city'
  },
  {
    title: 'Country',
    dataIndex: 'country',
    key: 'country'
  }
];

/**
 * TODO:
 * 1. Display a table of all organisations.
 * 2. Show a button for adding an organisation.
 *  1. The button opens a modal where the user can set the organisation details, and the ClinicAdmin for the organisation.
 * 3. After a successful submission, the table of organisations updates.
 *
 * @returns
 */
export function OrganiastionManagementPage() {
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const queryClient = useQueryClient();

  function showDrawer() {
    setIsDrawerVisible(true);
  }

  function handleCloseDrawer() {
    setIsDrawerVisible(false);
  }

  function handleSuccess() {
    setIsDrawerVisible(false);
    queryClient.invalidateQueries({ queryKey: ['organizations'] });
  }

  const organisationsQuery = useGetOrganizations();
  const errorList = useErrorList();
  useQueryErrorNotifier(organisationsQuery, errorList, 'Organisations');
  return (
    <PrintableRootPage title="Organization Management">
      <Flex gap={16} vertical>
        <Flex justify="space-between">
          <div />
          <div>
            <BaseButton type="primary" onClick={showDrawer}>
              Add an organiaztion
            </BaseButton>
          </div>
        </Flex>

        <Table
          dataSource={organisationsQuery.data}
          columns={columns}
          rowKey="id"
          loading={organisationsQuery.isLoading}
        />
      </Flex>

      <Drawer
        title="Add New Organization"
        width={720}
        onClose={handleCloseDrawer}
        open={isDrawerVisible}
        bodyStyle={{ paddingBottom: 80 }}
      >
        <AddOrganizationDrawer
          onCancel={handleCloseDrawer}
          onSuccess={handleSuccess}
        />
      </Drawer>
    </PrintableRootPage>
  );
}
